import { useEffect } from "react";
import ReactGA from 'react-ga';
import Home from "./components/Home";
import Demo from "./components/Demo";
import { Routes, Route } from "react-router-dom";
import "./App.scss";

ReactGA.initialize(process.env.REACT_APP_TRACKING_ID, {
  debug: false,
  titleCase: false,
  gaOptions: {
    userId: 1
  }
});

function App() {

  useEffect(()=>{
    ReactGA.pageview("My Portfolio");
  },[]);

  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/demo" element={<Demo url="https://ricku44.github.io/react-transition-noscroll" />} />
      <Route path="/scratch" element={<Demo url="https://main--eclectic-bavarois-4ba033.netlify.app/" />} />
    </Routes>
  );
}

export default App;
